import React from "react";

const MetricList = () => {
  return <h1>Metric List</h1>;
};

export default MetricList;
